








import Component from "vue-class-component";
import { Page } from "@/layout/mixin/Page";
import PageLayout from "@/common/layout/PageLayout.vue";

@Component({
  components: { PageLayout }
})
export default class AuthPage extends Page {
  title: string = "DataLogger - Informacje o urządzeniu";
}
